import React from 'react';
import { Header, Sidebar } from 'layout';
import OneSignal from 'react-onesignal';
import { toast } from 'react-toastify';
import subscribeDeviceService from 'services/subscribe-device/subscribe-device-service';
import { IApplicationState } from 'store/state/app-state';
import { useSelector } from 'react-redux';
import DialogForm from 'shared/components/DialogForm';
import ChangePasswordForm from 'pages/MyProfile/ChangePasswordForm';
import messages from 'shared/constants/messages';

const MainLayout: React.FC = ({ children }) => {
    const userData = useSelector((state: IApplicationState) => state.UserData);

    const [openDialog, setOpenDialog] = React.useState(false);

    const handleDialogOpen = () => setOpenDialog(true);
    const handleDialogClose = () => setOpenDialog(false);

    const toggleMenuClose = () => {
        const win_w = window.innerWidth;
        if (win_w < 1024) {
            document.body.classList.remove('show-menu');
            document.querySelector('.hamburger').classList.remove('is-active');
        }
    };
    React.useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        OneSignal.on('subscriptionChange', async (isSubscribed) => {
            const sid = await OneSignal.getUserId();
            if (sid) {
                await subscribeDeviceService.addEditSubscribeDevice({
                    subscriberId: sid,
                    userIdEnc: userData.userIdEnc,
                    isUnsubscribe: false,
                });
            }
        });
        if (userData?.needPasswordReset) {
            toast.error(messages.PasswordChangeError);
            handleDialogOpen();
        }
    }, []);

    return (
        <div className="wrapper">
            <Header />
            <Sidebar />
            <main className="main-content" onClick={toggleMenuClose}>
                {children}
                <DialogForm
                    openDialog={openDialog}
                    handleDialogClose={handleDialogClose}
                    title="Change Password"
                    className={'detail-dialog'}
                    hideCloseButton={true}
                    bodyContent={<ChangePasswordForm handleDialogClose={handleDialogClose} hideCloseButton={true} />}
                />
            </main>
        </div>
    );
};

export default MainLayout;
